import * as signalR from "@microsoft/signalr";

const connection = new signalR.HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_NOTIFICATION_API_URL ?? "https://notification.dev.agholmes-api-core.com/hub/notification")
    .build();

export const startConnection = async () => {
    await connection.start();
};

export const joinGroup = async (groupName) => {
    await connection.invoke("AddGroup", groupName);
};

export const removeGroup = async (groupName) => {
    await connection.invoke("RemoveGroup", groupName);
}

export const closeConnection = async () => {
    await connection.stop();
}

export const connectionValid = connection;